import React, { useState } from "react";
import { useAddress } from "@thirdweb-dev/react";
import "../styles/vesting-box3.css";
import { useVestingContract } from "../hooks/useVestingContract";
import { useTranslation } from "react-i18next";

const VestingBox3 = () => {
  const { t } = useTranslation();
  const address = useAddress();
  const { 
    hasVesting, 
    vestingStartDate, 
    vestingEndDate, 
    cliffEndDate,
    formatDate, 
    vestingInfo,
    isLoading 
  } = useVestingContract();
  const [showCalendarModal, setShowCalendarModal] = useState(false);

  // Calcular duración del cliff en días
  const getCliffDuration = () => {
    if (!vestingStartDate || !cliffEndDate) return 90; // Valor por defecto: 90 días
    
    const startTime = vestingStartDate.getTime();
    const cliffTime = cliffEndDate.getTime();
    const diffDays = Math.round((cliffTime - startTime) / (24 * 60 * 60 * 1000));
    
    return diffDays;
  };

  // Formatear el progreso para mostrar
  const formatProgress = () => {
    if (!vestingInfo || !vestingInfo.progressPercent) return "0%";
    return `${vestingInfo.progressPercent}%`;
  };

  return (
    <div className="vesting-box">
      <div className="box-content">
        <h4>{t("vestingBox3.calendar")}</h4>
        <div>
          <p className="value">{t("vestingBox3.start")}: {!address ? "-" : !hasVesting ? "-" : isLoading ? t("vestingBox3.loading") : vestingStartDate ? formatDate(vestingStartDate) : "-"}</p>
          <p className="value">{t("vestingBox3.end")}: {!address ? "-" : !hasVesting ? "-" : isLoading ? t("vestingBox3.loading") : vestingEndDate ? formatDate(vestingEndDate) : "-"}</p>
          <p className="value">{t("vestingBox3.cliffPeriod")}: {getCliffDuration()} {t("vestingBox3.days")}</p>
        </div>
        
        {/* Barra de progreso */}
        {hasVesting && !isLoading && (
          <div className="progress-container">
            <div className="progress-label">
              <span>{t("vestingBox3.progress")}: {formatProgress()}</span>
            </div>
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${vestingInfo.progressPercent || 0}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
      
      <button 
        id="view-calendar" 
        onClick={() => setShowCalendarModal(true)}
        disabled={!address || !hasVesting}
      >
        {t("vestingBox3.viewDetailedCalendar")}
      </button>

      {/* Modal del calendario detallado */}
      {showCalendarModal && (
        <div className="calendar-modal-overlay" onClick={() => setShowCalendarModal(false)}>
          <div className="calendar-modal" onClick={e => e.stopPropagation()}>
            <h3>{t("vestingBox3.calendar")}</h3>
            <div className="vesting-timeline">
              <div className="timeline-event">
                <div className="event-date">{formatDate(vestingStartDate)}</div>
                <div className="event-marker start"></div>
                <div className="event-description">{t("vestingBox3.vestingStart")}</div>
              </div>
              
              <div className="timeline-event">
                <div className="event-date">{formatDate(cliffEndDate)}</div>
                <div className="event-marker cliff"></div>
                <div className="event-description">{t("vestingBox3.cliffEnd")}</div>
              </div>
              
              <div className="timeline-event">
                <div className="event-date">{formatDate(vestingEndDate)}</div>
                <div className="event-marker end"></div>
                <div className="event-description">{t("vestingBox3.vestingEnd")}</div>
              </div>
              
              {/* Punto que indica la fecha actual */}
              <div className="timeline-now"></div>
            </div>
            <div className="monthly-releases">
              <h4>{t("vestingBox3.weeklyReleases")}</h4>
              <p>{t("vestingBox3.releaseDescription")}</p>
            </div>
            <button onClick={() => setShowCalendarModal(false)}>{t("vestingBox3.close")}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VestingBox3;
